<template>
  <div :id="id" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts'
import resize from '../mixins/resize'

export default {
  name: "lineChart",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: '速度'
    },
    data: {
      type: Object,
      default: null,
    },
    color: {
      type: Array,
      default () {
        return [];
      }
    },
    autoResize: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    // data () {
    //   //this.initChart();
    // }
  },
  mounted () {
    this.initChart()
    // this.timer = setTimeout(() => {   //设置延迟执行
    //   this.initChart()
    // }, 600)
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id))
      var thiz = this
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            color: "#fff",
          },
          backgroundColor: "rgba(0,0,0,0.5)",
          borderColor: "rgba(0,0,0,0.5)",
        },
        legend: {
          orient: 'horizontal',
          data: this.data.legend,
          align: 'right',
          top: 10,
          left: 20,
          textStyle: {
            color: '#fff'
          },
          itemWidth: 40,
          itemHeight: 6,
        },
        color: thiz.color,
        grid: {
          left: '3%',
          right: '4%',
          top: '35%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [
          {
            //name:'日期',
            type: 'category',
            boundaryGap: false,
            data: thiz.data.xData,
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: 'rgba(208,242,240,0.2)',
              },
            },
          }
        ],
        yAxis: [
          {
            //name:'设备数',
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: 'rgba(208,242,240,0.2)',
              },
            },
            minInterval: 1,
          }
        ],

        series: thiz.data.series
      })
    },
    dispose () {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    }
  }
}
</script>
